import { useCallback } from 'react'
import ModalSmallFilled from '../../../../../../../../../../baseComponents/ModalsLayouts/ModalSmallFilled'
import { ModalEditComponentProps } from '../../../../../../../../../../baseComponents/ModalsLayouts/types'
import { useFetchJSON } from '../../../../../../../../../../utils/hooks/useFetchJson'
import useIsLoading from '../../../../../../../../../../utils/hooks/useIsLoading'
import useTwinTranslation from '../../../../../../../../../../utils/hooks/useTwinTranslation'

interface ModalRecalculateSellOrderProps extends ModalEditComponentProps {}

const ModalRecalculateSellOrder: React.FC<ModalRecalculateSellOrderProps> = ({ setOpened, onSubmit, allRowData }) => {
    const { t } = useTwinTranslation()
    const { handleFetchJSON } = useFetchJSON({
        onSubmit,
        url: '/api/app/order/sell/sellOrder/recalculatePricesSellOrder',
        data: allRowData?.header || {}
    })
    const { handleFetchJSONLoading, loading } = useModalRecalculateSellOrderLogic({ handleFetchJSON })

    return (
        <ModalSmallFilled opened={true} loading={loading} setOpened={setOpened} onCancel={() => setOpened(null)} onAccept={handleFetchJSONLoading} translations={{
            title: t('sureRecalculateSellOrder', '¿Seguro que quieres recalcular este pedido de venta?'),
            subtitle: t('recalculateProductPrices', 'Recalculará los precios de los productos'),
            buttonAccept: t('accept', 'Aceptar'),
        }} />
    )
}

interface ModalRecalculateSellOrderLogicProps {
    handleFetchJSON: () => Promise<void>
}

const useModalRecalculateSellOrderLogic = ({ handleFetchJSON }: ModalRecalculateSellOrderLogicProps) => {
    const { endLoading, loading, startLoading } = useIsLoading()
    const handleFetchJSONLoading = useCallback(async () => {
        startLoading()
        await handleFetchJSON()
        endLoading()
    }, [startLoading, handleFetchJSON, endLoading])
    return { handleFetchJSONLoading, loading }
}


export default ModalRecalculateSellOrder